// extracted by mini-css-extract-plugin
export default {"addEntry":"AddJournalEntryButton_addEntry__02m08"};